import type { AiRollbackPlan, AiRollbackStrategy } from '../../types/aiOperational'

const strategyLabel: Record<AiRollbackStrategy, string> = {
  INVERSE_OPERATION: 'inverse operation',
  AUDIT_REPLAY: 'audit replay',
  SNAPSHOT_RESTORE: 'snapshot restore',
  NOT_REVERSIBLE: 'no rollback',
}

export const RollbackAvailabilityIndicator = ({ rollback }: { rollback?: AiRollbackPlan | null }) => {
  if (!rollback) return <span className="aiExecutionRollbackIndicator">Rollback not declared</span>
  return (
    <span className={`aiExecutionRollbackIndicator ${rollback.reversible ? 'isAvailable' : 'isUnavailable'}`}>
      {rollback.reversible ? 'Rollback available' : 'Rollback unavailable'} · {strategyLabel[rollback.strategy]}
    </span>
  )
}
